import { Injectable } from '@angular/core';
import { ConfigService } from '../../services/config/config.service';
import { AppConfigService } from '../../services/app-config.service';

@Injectable({providedIn: 'root'})
export class HotjarService {
    constructor(private appConfigService: AppConfigService) {
    }

    load() {
        if (ConfigService.get('isProduction')) {
            this.loadHotjar();
        }
    }

    private loadHotjar() {
        const node = document.createElement('script');
        node.type = 'opt-in';
        node.setAttribute('data-name', 'hotjar');
        node.setAttribute('data-type', 'application/javascript');
        node.text = `
            (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:` + this.appConfigService.getAppConfig().hotjarKey + `,hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `;
        document.getElementsByTagName('head')[0].appendChild(node);
    }
}
